// import React from 'react';
// import { translate } from 'utils/common';

export function generateQuery(searchValue, queryFilter, valueArr) {

    let processesContextFilter = [];
    queryFilter.contextFilter.forEach((data) => {
        processesContextFilter.push({
            field: data.field,
            value: (valueArr.hasOwnProperty(data.field) && valueArr[data.field]) ? [valueArr[data.field]] : data.value ? [data.value] : []
            // if value exists in the conf, that till take eg: { "field": "workflowstate", "value": ["published"]}
        })
    })
    return {
        q: {
            lang: valueArr["lang"] || 'EN',
            term: searchValue,
            completionFields: queryFilter.completionFields,
            fields: queryFilter.fields,
            contextFilter: processesContextFilter
        }
    }

}

export function generateQueryFromMetaData(searchValue, queryFilter, valueArr, lang, fullData) {
    let q = {}
    const processFilter = () => {
        let res = [];
        Object.keys(valueArr).forEach((key) => {
            if (key !== 'lang') {
                
            }
            res.push({
                field: key,
                value: [valueArr[key]]
            })
        })
        return res;
    };
    q = { ...queryFilter, term: searchValue, lang: lang ? lang : fullData[lang.formKey] || 'EN' };
    // q = { ...queryFilter, term: searchValue, lang: lang.value ? lang.value : fullData[lang.formKey] || 'EN' };
    q.contextFilter = processFilter();

    return { q };

} 